<script>
export default {
	name: 'IconSvgUp',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<template>
	<div>
		<svg :width="size" :height="size" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd"
				  d="M11.3683 8.36838C11.6168 8.11987 12.0197 8.11987 12.2682 8.36838L18.6319 14.732C18.8804 14.9805 18.8804 15.3835 18.6319 15.632C18.3833 15.8805 17.9804 15.8805 17.7319 15.632L11.8182 9.71831L5.90458 15.632C5.65606 15.8805 5.25314 15.8805 5.00462 15.632C4.75611 15.3835 4.75611 14.9805 5.00462 14.732L11.3683 8.36838Z"
				  :fill="color" />
		</svg>
	</div>
</template>

<style scoped>

</style>